interface Props {
  side: 'a' | 'b';
  questions: string[] | null;
}

export default function QuestionsList({ side, questions }: Props) {
  const sideLabel = side.toUpperCase();
  const tone = side === 'a' ? 'border-blue-300 bg-blue-50' : 'border-green-300 bg-green-50';

  return (
    <div className={`border ${tone} rounded-lg p-3`}>
      <div className="text-xs uppercase text-gray-600 mb-2 font-semibold">Side {sideLabel} questions</div>
      {questions && questions.length > 0 ? (
        <ol className="list-decimal list-inside space-y-1 text-sm text-gray-800">
          {questions.map((q, i) => (
            <li key={i}>{q}</li>
          ))}
        </ol>
      ) : (
        <div className="text-sm text-gray-500 italic">No questions for this side.</div>
      )}
    </div>
  );
}
